import React, { useState } from "react";

export default function NotificationSettings() {
  const [emailNotif, setEmailNotif] = useState(true);
  const [smsNotif, setSmsNotif] = useState(false);

  const handleSave = () => {
    // TODO: Save preferences to backend
    alert("Notification preferences saved!");
  };

  return (
    <section className="bg-gray-50 dark:bg-gray-900 p-6 rounded-lg shadow-md max-w-xl mx-auto">
      <h3 className="text-2xl font-semibold mb-6 text-gray-900 dark:text-white">Notification Settings</h3>

      <div className="space-y-4">
        <label className="flex items-center space-x-3">
          <input
            type="checkbox"
            checked={emailNotif}
            onChange={() => setEmailNotif(!emailNotif)}
            className="form-checkbox h-5 w-5 text-blue-600"
          />
          <span className="text-gray-700 dark:text-gray-300">Email Notifications</span>
        </label>

        <label className="flex items-center space-x-3">
          <input
            type="checkbox"
            checked={smsNotif}
            onChange={() => setSmsNotif(!smsNotif)}
            className="form-checkbox h-5 w-5 text-blue-600"
          />
          <span className="text-gray-700 dark:text-gray-300">SMS Notifications</span>
        </label>
      </div>

      <button
        onClick={handleSave}
        className="mt-6 bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-blue-700 transition"
      >
        Save Preferences
      </button>
    </section>
  );
}
